import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect, useState } from "react";
import Dashboard from "@/pages/Dashboard";
import AuthGate from "@/components/AuthGate";
import PublicFunnel from "@/pages/PublicFunnel";
import Register from "@/pages/Register";
import { useSession } from "@/hooks/useSession";

const LANG_LS_KEY = "persona-dm-lang";

function ProtectedApp() {
  const { session, ready } = useSession();
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem(LANG_LS_KEY) || "sk";
    } catch {
      return "sk";
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(LANG_LS_KEY, lang);
    } catch {
      /* ignore */
    }
  }, [lang]);

  if (!ready) {
    return (
      <div className="cockpit-bg min-h-screen w-full flex items-center justify-center">
        <span className="typing" data-testid="app-boot-loading">
          <span />
          <span />
          <span />
        </span>
      </div>
    );
  }

  if (!session) {
    return <AuthGate lang={lang} onToggleLang={setLang} />;
  }
  return <Dashboard lang={lang} onToggleLang={setLang} session={session} />;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#09090B] text-white">
      <BrowserRouter>
        <Routes>
          {/* Public linkdrop page — NO auth */}
          <Route path="/f/:slug" element={<PublicFunnel />} />
          {/* Public registration */}
          <Route path="/register" element={<Register />} />
          {/* Everything else = protected dashboard */}
          <Route path="/*" element={<ProtectedApp />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
